import React, { useMemo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as columnFormatters from "./column-formatter";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import {
  sortCaret,
  getHandlerTableChange,
} from "../../../_metronic/_helpers";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../_metronic/_partials/controls";
import GlobalLoader from "../../../common/loaders/LoadingBox";
import { useWocommCategoriesUIContext } from "../WocommCategoriesUIContext";
import { fetchWocommCategories } from "../../../actions/wocommerce-categories/wocommerceCategories";

export function WocommCategoriesTable() {

  const [loader, setLoader] = useState(true);

  const { categories } = useSelector(
    (state) => ({
      categories:
        state.wocommerceCategories.categories,
    }),
    shallowEqual
  );
  const [searchQuery, setSearchQuery] = useState('');



  const handleOnChange = (e) => {
    setSearchQuery(e.target.value)
    wocommUIProps.setQueryParams((prev) => { return { ...prev, search: e.target.value } }
    )
  }
  const dispatch = useDispatch();

  const wocommUIContext = useWocommCategoriesUIContext();
  const wocommUIProps = useMemo(() => {
    return {
      ids: wocommUIContext.ids,
      setIds: wocommUIContext.setIds,
      queryParams: wocommUIContext.queryParams,
      setQueryParams: wocommUIContext.setQueryParams,
      openEditCategoryPage: wocommUIContext.openEditWocommCategoryPage,
      openViewWocommCategoryPage: wocommUIContext.openViewWocommCategoryPage,
    };
  }, [wocommUIContext]);


  async function getWocommCategoriesData() {
    setLoader(true);
    await dispatch(fetchWocommCategories(wocommUIProps.queryParams));
    setLoader(false);
  }

  useEffect(() => {
    getWocommCategoriesData();
  }, [dispatch, wocommUIProps.queryParams]);

  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "25", value: 25 },
    { text: "50", value: 50 },
    { text: "100", value: 100 },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: 55,
    sizePerPageList: sizePerPageList,
    sizePerPage: wocommUIProps.queryParams.pageSize,
    page: wocommUIProps.queryParams.pageNumber,
  };
  
  const columns = [
    {
      dataField: "index",
      text: "Id",
      sort: false,
      // sortCaret: sortCaret,
      formatter: columnFormatters.RowIndex,
      style: { minWidth: "70px" },
      formatExtraData: {paginationOptions}
    },
    {
      dataField: "category_name",
      text: "Category Name",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
    {
      dataField: "order",
      text: "Category Order",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },


    // {
    //   dataField: "create_date",
    //   text: " Created At",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   formatter: columnFormatters.CreateDateColumnFormatter,
    //   style: {
    //     minWidth: "100px",
    //   },
    // },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditCategoryPage: wocommUIProps.openEditCategoryPage,
        openViewCategoryPage: wocommUIProps.openViewWocommCategoryPage,
        total: 55
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-1",
      style: {
        minWidth: "100px",
      },
    },
  ];


  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              paginationProps={paginationProps}
            >
              <div className="row">
                <div className="col-12">
                  <div class="form-group input-icon" >
                    <input type="email" class="form-control" value={searchQuery} onChange={handleOnChange} placeholder="Search..."></input> <span>
                      <i className="flaticon2-search-1 text-muted"></i>
                    </span>
                  </div>
                </div>

              </div>
              <BootstrapTable
                wrapperClasses='table-responsive '
                classes='table table-head-custom table-vertical-center'
                bootstrap4
                bordered={false}
                remote
                keyField='_id'
                columns={columns}
                // data={products}
                data={categories === null ? [] : categories}
                onTableChange={getHandlerTableChange(
                  wocommUIProps.setQueryParams
                )}
                {...paginationTableProps}
                noDataIndication={() => categories === null ? '' : <div className="no-data-indication">No records found</div>}
              >
              </BootstrapTable>
              {loader && <GlobalLoader />}
            </Pagination>
          );
        }}
      </PaginationProvider>

    </>
  );
}